import {CellContent} from "../../../../components/ExTable";
import React from "react";
import {hasJsonStructure} from "../helpers";
import HistoryInformationCell from "./HistoryInformationCell";

export const formatInformationCellContent =
    (setViewJson: (obj: object) => void, setViewText: (text: string) => void) =>
    ({row}: {row: any}): CellContent => {
        return {
            title: !hasJsonStructure(row.information) ? row.information : undefined,
            node: (
                <HistoryInformationCell
                    entry={row}
                    onOpenJsonView={(jsonObj) => setViewJson(jsonObj)}
                    onOpenTextView={(text) => setViewText(text)}
                />
            ),
        };
    };
